import PropTypes from "prop-types";
import { ContentMenuLink } from "../Layout/templates";
import useResourceModal from "../../hooks/modalHooks/useResourceModal";
import ResourceMenuModal from "./ResourceMenuModal";

/**
 * Special link component for the main resource menu in the app sidebar
 * Opens resource menu page in modal when accessed from non-resource contexts
 */
const ResourceMenuLink = ({ children, className = "", ...props }) => {
  return (
    <ContentMenuLink
      contentType="resources"
      className={className}
      useModalHook={useResourceModal}
      menuModalComponent={ResourceMenuModal}
      {...props}
    >
      {children}
    </ContentMenuLink>
  );
};

ResourceMenuLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ResourceMenuLink;
